module.exports = __webpack_public_path__ + "static/media/washington-dc-29.fc18be8d.jpg";